import { Node } from 'prosemirror-model'
import { EditorState, Plugin } from 'prosemirror-state'
import { Decoration, DecorationSet } from 'prosemirror-view'
import Styles from '../ProseInput.module.scss'

const isEmpty = (doc: Node) => {
  const hasNoChildren = doc.childCount === 0
  const isEmptyTextBlock = doc.childCount === 1 && doc.firstChild?.isTextblock && doc.firstChild?.content.size === 0

  return hasNoChildren || isEmptyTextBlock
}

const PlaceholderPlugin = (text: string) => {
  return new Plugin({
    props: {
      decorations(state) {
        const { doc } = state
        if (isEmpty(doc)) {
          const position = doc.inlineContent ? 0 : 1
          const placeholder = document.createElement('span')
          placeholder.classList.add(Styles.placeholder)
          placeholder.setAttribute('data-placeholder', text)

          return DecorationSet.create(doc, [Decoration.widget(position, placeholder)])
        }
      },
      attributes: (state: EditorState) => {
        if (isEmpty(state.doc)) {
          return {
            class: Styles.empty,
          }
        }
      },
    },
  })
}

export { PlaceholderPlugin }
